import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import Type from 'components/Type'
import Stack from '@mui/material/Stack'

const VARIANTS = {
  mainCool: {
    color: 'text.neutralCool_700',
    '&:hover': {
      color: '#5E6D73',
    },
  },
  inverse: {
    color: 'text.inverse',
  },
  inverseBlend: {
    color: 'text.inverse',
    opacity: .6,
    '&:hover': {
      opacity: 1,
    },
  },
  tertiary: {
    color: 'text.tertiary',
    '&:hover': {
      color: '#0081CC',
    },
  },
  primaryHue: {
    color: 'text.primaryHue',
    '&:hover': {
      color: '#E63C33',
    },
  },
  secondary: {
    color: 'text.secondary',
    '&:hover': {
      color: 'text.secondary',
    },
  },
}

const IconAction = ({ children, icon, reverse, font, variant, textAlign, iconProps, ...props }) => {
  const {
    sx,
    ...otherProps
  } = props

  return (
    <Stack
      sx={theme => ({
        ...theme.internalMixins.columns({ gap: .5 }),
        ...VARIANTS[variant],
        transition: theme.state.transition.main,
        cursor: 'pointer',
        ...sx,
      })}
      {...otherProps}
      className="icon-action"
    >
      {!reverse && <Icon icon={icon} {...iconProps} />}
      <Type variant={font} textAlign={textAlign || (reverse ? 'right' : 'left')}>{children}</Type>
      {reverse && <Icon icon={icon} {...iconProps} />}
    </Stack>
  )
}

IconAction.propTypes = {
  icon: PropTypes.string,
  reverse: PropTypes.bool,
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),
  font: PropTypes.oneOf(['button', 'buttonLarge', 'dataSmall', 'inherit', 'dataMicro']),
  variant: PropTypes.oneOf(['mainCool', 'inverse', 'inverseBlend', 'tertiary', 'primaryHue']),
  iconProps: PropTypes.object,
}

IconAction.defaultProps = {
  icon: 'AddLarge',
  font: 'button',
  variant: 'mainCool',
  iconProps: {},
}

export default IconAction
